import {defineStore} from 'pinia'
import ApiService from "@/core/services/ApiService";
import { ElNotification } from "element-plus";
import {catchErrorMessages} from "@/utils/seasonRefusal";

export const useGlobalStore = defineStore('globalStore', {
  state: () => {
    return {
      pageTitle: '',
      pageBreadcrumbPath: [],
      activeBookingId: null,
      activeBookingHistoryIdMutation: null,
      activeBookingHistoryId: 0,
      catchError: [],
      asideMenuIsOpen: false,
      activePhoneCall: null,
      // activePhoneCall: <any>{
      //   "callId": 77800,
      //   "phoneNumber": "+37369222269",
      //   "name": "test test",
      //   "history": [{"id": 77795, "name": "Tudor", "date": "3 secunde", "comment": ""}, {
      //     "id": 77796,
      //     "name": "Tudor",
      //     "date": "3 secunde",
      //     "comment": ""
      //   }, {"id": 77797, "name": "Tudor", "date": "3 secunde", "comment": ""}, {
      //     "id": 77798,
      //     "name": "Tudor",
      //     "date": "3 secunde",
      //     "comment": ""
      //   }, {"id": 77799, "name": "Tudor", "date": "3 secunde", "comment": ""}, {
      //     "id": 77794,
      //     "name": "Tudor",
      //     "date": "8 minute",
      //     "comment": ""
      //   }, {"id": 77793, "name": "Tudor", "date": "9 minute", "comment": ""}, {
      //     "id": 77792,
      //     "name": "Tudor",
      //     "date": "1 oră",
      //     "comment": ""
      //   }],
      //   "bookingCount":33,
      //   "customerId":92729
      // },
      wsStatus: true,
      muteNotifications: false,
    }
  },
  actions: {
    addBodyClassName(className) {
      document.body.classList.add(className);
    },
    removeBodyClassName(className) {
      document.body.classList.remove(className);
    },
    addBodyAttribute(attribute, value) {
      document.body.setAttribute(attribute, value);
    },
    removeBodyAttribute(attribute) {
      document.body.removeAttribute(attribute);
    },
    openBooking(_id) {
      // this.activeBookingId = id;
      // if (id) {
      //   // @ts-ignore
      //   const modal = new Modal(document.getElementById("kt_modal_edit_booking"));
      //   modal.show();
      // }
      // this.openBook(id);
    },
    catchErrors(errors) {
      // D33/D40: robust for bodies without `errors` (owner 409s, abort 403/404,
      // 500, network) and never a raw P06 refusal code; `errors` rows unchanged.
      for (const message of catchErrorMessages(errors)) {
        this.catchError.push({
          // @ts-ignore
          message,
        })
      }
    },
    addNotificationSuccess(message) {
      // const toast = useToast();

      // toast.success(message, {
      //   timeout: 7000,
      //   position: POSITION.BOTTOM_LEFT
      // });
      // ElMessage({
      //   message: message,
      //   type: 'success',
      //   duration: 7000
      // })
      ElNotification({
        // title: 'Custom Position',
        message: message,
        position: 'bottom-left',
        type: 'success',
      })
    },
    addNotificationWarning(message) {
      ElNotification({
        message: message,
        position: 'bottom-left',
        type: 'warning',
      })
    },
    addNotificationError(message) {
      // const toast = useToast();

      // toast.error(message, {
      //   timeout: 7000,
      //   position: POSITION.BOTTOM_LEFT
      // });
      // ElMessage({
      //   message: message,
      //   type: 'error',
      //   duration: 7000
      // })
      ElNotification({
        // title: 'Custom Position',
        message: message,
        position: 'bottom-left',
        type: 'error',
      })
    },
    addNotificationInfo(message) {
      // const toast = useToast();

      // toast.error(message, {
      //   timeout: 7000,
      //   position: POSITION.BOTTOM_LEFT
      // });
      // ElMessage({
      //   message: message,
      //   type: 'info',
      //   duration: 7000
      // })
      ElNotification({
        // title: 'Custom Position',
        message: message,
        position: 'bottom-left',
        type: 'info',
      })
    },

    toggleAsideMenu(toggle = true) {
      if (toggle) {
        this.asideMenuIsOpen = !this.asideMenuIsOpen;
      }
      const body = document.querySelector('body');
      if (!body) {
        return;
      }
      if (!this.asideMenuIsOpen) {
        body.setAttribute('data-kt-aside-minimize', 'on');
      } else {
        body.removeAttribute('data-kt-aside-minimize');
      }
      localStorage.setItem('asideMenuIsOpen', this.asideMenuIsOpen ? '1' : '0');
    },
    getAsideMenuIsOpen() {
      this.asideMenuIsOpen = localStorage.getItem('asideMenuIsOpen') === '1';
      this.toggleAsideMenu(false);
    },

    call(phoneNumber) {
      const globalStore = useGlobalStore();
      return ApiService.post('/users/call', {phone_number: phoneNumber})
        .then(() => {
          globalStore.addNotificationSuccess('Verifica daca aplicatia este deschisa pe telefonul tau.')
        })
        .catch(() => {
          globalStore.addNotificationError('A aparut o eroare la apelare.')
        })
    },
  },
})
